import {
  BaseActionObject,
  StateNodeConfig,
  assign,
  DoneInvokeEvent
} from "xstate4"
import { Context, Transitions } from "../../../types"
import { getServiceErrorMessage } from "../../../helpers"

export const downloadScoresByStudentTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "downloadScoresByStudent",
    onDone: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => ({
        snackbar: evt.data.snackbar
      }))
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<Error>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("downloadScoresByStudent", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
